<template>
  <!-- style="--clr-back: var(--clr-black-0); --padding-content: 1rem" -->
  <SolfigrNodeCompareMain
    ref="studyranges"
    style="--clr-back: var(--clr-black-0)"
    rangeTab="range"
    :namespace="namespace"
    :hSpot="hSpot"
    :messages1="messages1"
    :messages2="messages2"
    :players1="players1"
    :players2="players2"
    :opponent1="opponent1"
    :opponent2="opponent2"
    :hero1="l_hero1.hero"
    :heroRange1="l_hero1.heroRange"
    :solution1="l_hero1.solution"
    :solution_picked1="l_hero1.solution_picked"
    :evProps1="evProps1"
    :tableGroups1="l_hero1.tableGroups"
    :hero2="l_hero2.hero"
    :heroRange2="l_hero2.heroRange"
    :solution2="l_hero2.solution"
    :solution_picked2="l_hero2.solution_picked"
    :evProps2="evProps2"
    :tableGroups2="l_hero2.tableGroups"
    :catDraws="l_solDynamic.catDraws"
    :catHands="l_solDynamic.catHands"
    :catEqBuckets="l_solDynamic.catEqBuckets"
    :catEqBucketsAdvanced="l_solDynamic.catEqBucketsAdvanced"
    :filterCategories="filterCategories"
    :filterCombos="filterCombos"
    :playersDetail="playersDetail"
    :street="hSpot_street"
    :bettingInfo
    :showBetsIn="showBetsIn"
    :isPreflop="isPreflop"
    :mobile="mobile"
    :max1280="max1280"
    :viewProps="l_viewProps"
    :ccProps="l_ccProps"
    :grouping="grouping"
    :useHex="useHex"
    :skeletonOnly="!l_hero2.hero?.position"
    :tableMouseover="tableMouseover"
    :filteredHeroHandsIds="$store.getters.sol_filter_playersHandsIds[0]"
    :filteredOpponentHandsIds="$store.getters.sol_filter_playersHandsIds[1]"
    :heroHandsIds="playersDetail[0].hands_ids"
    :opponentHandsIds="playersDetail[1].hands_ids"
    @update:swRangeContentHero="str => (swRangeContentHero = str)"
  >
    <template #table_hero_title1>
      <SolfigrHistorySelect
        tour="ndccurrstrategy"
        :customSolutionId="hSpot_customSolId"
        :item="heroSolutionItem1"
        :historyCallId="historyCallId"
        :name="$t('common.current')"
        style="flex-direction: row-reverse"
        @loaded="handleHistoryLoaded"
        @click:item="item => handlePlayerSolChange({ item, num: 1 })"
      />
    </template>
    <template #table_hero_title2>
      <SolfigrHistorySelect
        tour="ndcprevstrategy"
        :customSolutionId="hSpot_customSolId"
        :item="heroSolutionItem2"
        :historyCallId="historyCallId"
        :name="$t('common.previous')"
        @click:item="item => handlePlayerSolChange({ item, num: 2 })"
      />
      <!-- @loaded="handleHistoryLoaded" -->
    </template>
    <template #error>
      <div class="gw_box slndcmp_messagebox anim-fade-in">
        <IconAndText
          icon="mdi-alert-circle-outline"
          style="--icon-size: 5rem; --icon-color: var(--clr-error)"
          :title="$t('messages.oops_error')"
          :subtitle="$t('messages.opps_error_sub')"
        />
      </div>
    </template>
    <template #no_solution>
      <div class="gw_box slndcmp_messagebox anim-fade-in">
        <IconAndText
          icon="mdi-information"
          style="--icon-size: 5rem; max-width: 18rem"
          :title="$t('nodelock.no_solution')"
          :subtitle="$t('nodelock.no_solution_sub')"
        />
      </div>
    </template>
  </SolfigrNodeCompareMain>
</template>

<script>
// in this file the goal is to make the component compatible with players array, previously we have hero and opponent, now instead, we have players array, and we need to make the component compatible with that
// and first player in the array is always hero
// now we want to replace all hero1, hero2, opponent1, opponent2 with players1 and players2

import IconAndText from '@/components/Poker/Overlays/IconAndText'
import { SNK } from '@/helpers/helpers'
import { getSolProps, toggleSolProps, getSolViewProps } from '@/helpers/solution'

import SolfigrNodeCompareMain from '@/components/Dialogs/Solfigr/SolfigrNodeCompareMain'
import SolfigrHistorySelect from '@/components/Dialogs/Solfigr/SolfigrHistorySelect'
import float_mix from '@/mixins/float_mix'
import format_mix from '@/mixins/format_mix'
import fetch_mix from '@/mixins/fetch_mix'

export default {
  name: 'SolfigrNodeCompare',
  components: {
    SolfigrNodeCompareMain,
    SolfigrHistorySelect,
    IconAndText,
  },
  mixins: [format_mix, float_mix, fetch_mix],
  props: {
    primaryNamespace: { required: true, type: String },
    namespace: { required: true, type: String },
    hotkeysPressed: Array,
  },
  data() {
    this.historyCallId = Date.now()
    return {
      heroCall1: null,
      heroCall2: null,
      heroUpdated1: 0,
      heroUpdated2: 0,

      heroSolutionItem1: null,
      heroSolutionItem2: null,
      swRangeContentHero: 'swv_strategy',
      heroTournamentEvsConverter1: null,
    }
  },
  created() {
    this.swRangeContentHero = this.$store.getters.sw_range_content_hero

    const callBase = {
      conf: {
        endpoint: 'poker/solution/',
        hasCancel: false,
        waitForCache: true,
        gwCacheAdd: true,
      },
      loading: true,
      loaded: false,
      status: 0,
      prevStatus: 0,
    }
    this.heroCall1 = { ...callBase }
    this.heroCall2 = { ...callBase }

    // TODO: remove after 3way release
    this.opponent1 = {}
    this.opponent2 = {}

    this.players1 = []
    this.players2 = []

    this.apiData1 = null
    this.solution1 = []
    this.solution_picked1 = []
    this.evProps1 = null
    this.tableGroups1 = this.$store.getters.ske_tableGroups()
    this.combos1 = this.$store.getters.ske_combos()

    this.apiData2 = null
    this.solution2 = []
    this.solution_picked2 = []
    this.evProps2 = null
    this.tableGroups2 = this.$store.getters.ske_tableGroups()
    this.combos2 = this.$store.getters.ske_combos()

    this.categories1 = []
    this.categories2 = []

    this.catDraws = []
    this.catHands = []
    this.catEqBuckets = []
    this.catEqBucketsAdvanced = []
  },
  methods: {
    startTour() {
      setTimeout(() => {
        this.$store.dispatch('globals_action', 'component_triggered_tour_NodecompareDialog')
      }, 120)
    },
    handleHistoryLoaded({ items }) {
      const item1 = items.find(i => i.id === this.hSpot_customSolId)
      const item2 = items.find(i => i.id !== this.hSpot_customSolId) || item1

      if (!item1) {
        this.$store.dispatch('messages', {
          type: 'error',
          text: 'No similar nodes found',
        })
        this.heroCall1.loading = false
        this.heroCall2.loading = false
        this.heroCall1.error = true
        this.heroCall2.error = true
        return
      }
      this.handlePlayerSolChange({ item: item1, num: 1 })
      this.handlePlayerSolChange({ item: item2, num: 2 })

      this.startTour()
    },
    handlePlayerSolChange({ item, num }) {
      this[`heroSolutionItem${num}`] = item
      const params = {
        ...this.$store.getters[SNK('solparams_strategy', this.primaryNamespace)],
        custom_solution_id: item.id,
        board: item.board,
      }
      this.getDataHero({ num, params })
    },
    async getDataHero({ num, params }) {
      const callId = `poker/solution/${new URLSearchParams(params)}`
      const callConf = this[`heroCall${num}`]
      callConf.conf = {
        ...callConf.conf,
        callId,
        params,
        gwCacheId: callId,
      }
      const { call, data, error } = await this.fch_getData(callConf)
      if (error) return

      // this.heroCall1.error = true
      // this.heroCall1.loading = false
      // this.heroCall1.loaded = true
      // this.heroCall1.status = 204

      if (call.status === 200) {
        this.$store.dispatch(SNK('sol_filters_reset', this.namespace))
        this.$store.commit(SNK('sol_detail_set', this.namespace), {
          key: 'players_detail',
          playerProperty: 'group_id',
          value: '',
          player: '0',
        })
        this.setSolProps(data, num)
      }
    },
    setSolProps(apiData, num) {
      const res = getSolProps({
        apiData,
        combos: this[`combos${num}`],
        tableGroups: this[`tableGroups${num}`],
      })

      this[`players${num}`] = res.players
      this[`apiData${num}`] = apiData
      this[`opponent${num}`] = res.players[1]
      this[`heroRange${num}`] = res.players[0]?.range || []
      this[`solution${num}`] = res.solution
      this[`solution_picked${num}`] = res.solution_picked
      this[`evProps${num}`] = res.evProps
      this[`tableGroups${num}`] = res.tableGroups
      this[`combos${num}`] = res.combos
      this[`categories${num}`] = {
        catDraws: res.catDraws,
        catHands: res.catHands,
        catEqBuckets: res.catEqBuckets,
        catEqBucketsAdvanced: res.catEqBucketsAdvanced,
      }

      if (num === 1) {
        this.heroTournamentEvsConverter1 = res.players[0].tournament_evs_converter
      }

      const player = !this.apiData2 ? 'opponent' : num === 1 ? 'hero' : 'opponent'
      const playerPlayerIdx = player === 'hero' ? 0 : 1

      const switchCatPlayer = catName =>
        (!this.apiData2 ? res[catName] : this[catName]).map((i, idx) => {
          i[player] = res[catName][idx].players[0]
          i.players[playerPlayerIdx] = res[catName][idx].players[0]
          return i
        })

      this.catDraws = switchCatPlayer('catDraws')
      this.catHands = switchCatPlayer('catHands')
      this.catEqBuckets = switchCatPlayer('catEqBuckets')
      this.catEqBucketsAdvanced = switchCatPlayer('catEqBucketsAdvanced')

      this[`heroUpdated${num}`] = Date.now()
    },
    toggleSolProps() {
      if (this.heroCall1.loaded) {
        const res1 = toggleSolProps({
          filter: this.filterCombos,
          solution: this.solution1,
          combos: this.combos1,
          tableGroups: this.tableGroups1,
        })
        this.solution_picked1 = res1.solution_picked
        this.combos1 = res1.combos
        this.tableGroups1 = res1.tableGroups
        this.players1[0].total_range_filtered = res1.playersTotalRange[0]
      }

      if (this.heroCall2.loaded) {
        const filterCombos = {
          ...this.filterCombos,
          categories: this.filterCombos.categories.map(i => ({
            ...i,
            hero: i.opponent,
          })),
        }
        const res2 = toggleSolProps({
          filter: filterCombos,
          solution: this.solution2,
          combos: this.combos2,
          tableGroups: this.tableGroups2,
        })

        this.solution_picked2 = res2.solution_picked
        this.combos2 = res2.combos
        this.tableGroups2 = res2.tableGroups
        this.players2[0].total_range_filtered = res2.playersTotalRange[0]
      }

      if (this.heroCall1.loaded) this.heroUpdated1 = Date.now()
      if (this.heroCall2.loaded) this.heroUpdated2 = Date.now()
    },
    getMessages(num) {
      const call = this[`heroCall${num}`]
      // let updated = this[`heroUpdated${num}`]
      const res = call.error
        ? ['error']
        : call.loading
          ? ['loading']
          : call.status === 204
            ? ['no_solution']
            : null

      // return ['error']
      // return ['loading']
      // return ['no_solution']
      return res
    },
  },
  computed: {
    playersDetail() {
      return this.$store.getters[SNK('sol_detail_players', this.namespace)] || []
    },
    tableMouseover() {
      return this.$store.getters[SNK('sol_detail_tableMouseover', this.namespace)]
    },
    filterCombos() {
      return this.$store.getters[SNK('sol_filter_combos', this.namespace)]
    },
    filterCategories() {
      return this.$store.getters[SNK('sol_filter_categories', this.namespace)]
    },
    filterActive() {
      return this.$store.getters[SNK('sol_filter_active', this.namespace)]
    },

    l_viewProps() {
      const args = {
        sw_tabs_study: 'range',
        sw_range_content_hero: this.swRangeContentHero,
        sw_tabs_strategy: this.swRangeContentHero,
        sol_data_players: this.$store.getters.sol_data_players,
        sol_data_street: this.$store.getters.sol_data_street,
        sol_detail_player: this.$store.getters.sol_detail_player,
        sol_data_opponent: this.$store.getters.sol_data_opponent,
        sol_data_hero: this.$store.getters.sol_data_hero,
        sw_hand_content: this.$store.getters.sw_hand_content,
        sw_range_content_opponent: this.$store.getters.sw_range_content_opponent,
        sw_range_height: this.$store.getters.sw_range_height,
        sw_combos_columns: this.$store.getters.sw_combos_columns,
        sw_combos_chart_style: this.$store.getters.sw_combos_chart_style,
        showHandValue: this.$store.getters.mergedUserSettings.showHandValue,
      }
      // console.log(args, this.swRangeContentHero)
      return getSolViewProps(args)
    },
    l_ccProps() {
      return {
        hasRangesComparisonItem: true,
        hasRangesComparison: true,
      }
    },
    messages1() {
      return this.getMessages(1)
    },
    messages2() {
      return this.getMessages(2)
    },
    l_hero1() {
      const res = {
        hero: this.players1[0] || {},
        heroRange: this.players1[0]?.range || [],
        solution: this.solution1,
        solution_picked: this.solution_picked1,
        tableGroups: this.tableGroups1,
      }
      return this.heroUpdated1 ? res : res
    },
    l_hero2() {
      const res = {
        hero: this.players2[0] || {},
        heroRange: this.players2[0]?.range || [],
        solution: this.solution2,
        solution_picked: this.solution_picked2,
        tableGroups: this.tableGroups2,
      }
      return this.heroUpdated2 ? res : res
    },
    l_solDynamic() {
      const res = {
        // solData: this.solData,
        catDraws: this.catDraws,
        catHands: this.catHands,
        catEqBuckets: this.catEqBuckets,
        catEqBucketsAdvanced: this.catEqBucketsAdvanced,
      }
      // console.log('l_solDynamic', res)
      // debugger
      return this.heroUpdated1 + this.heroUpdated2 ? res : res
    },

    isPreflop() {
      return this.$store.getters.sol_data_street === 'preflop'
    },
    useHex() {
      return this.$store.getters.sw_actions_grouping === 'swv_grouping_none'
    },

    hSpot() {
      return this.$store.getters[SNK('history_spot', this.primaryNamespace)]
    },
    hSpot_street() {
      return this.hSpot?.street
    },
    hSpot_customSolId() {
      return this.hSpot?.custom_solution_id
    },
    sol_hsBoard() {
      return this.$store.getters[SNK('history_spot_board', this.primaryNamespace)]
    },

    solElite() {
      return this.$store.getters[SNK('sol_elite', this.primaryNamespace)]
    },
    hasPremiumGameformat() {
      const { subs } = this.$store.getters.user_info
      const anyPremiumPurchased = subs.some(i => i.plan.tier === 'PREMIUM')
      const anyElitePurchased = subs.some(i => i.plan.tier === 'ELITE')
      return !!(anyPremiumPurchased || anyElitePurchased)
    },

    max1280() {
      return this.$store.getters.screen_max1280
    },
    mobile() {
      return this.$store.getters.globals_mobile
    },
    grouping() {
      return this.$store.getters.sw_actions_grouping
    },
    showBetsIn() {
      return this.$store.getters.show_bets_in
    },
    bettingInfo() {
      return {
        pot: this.hSpot.pot,
        showEvIn: this.$store.getters.show_ev_in,
        showEvIcmIn: this.$store.getters.show_ev_icm_in,
        evIcmConverters: [this.heroTournamentEvsConverter1],
      }
    },

    // --- messages
    hasEliteSingleFlopOnly() {
      const flopBoard = this.$store.getters[SNK('street_board', this.primaryNamespace)]('flop')
        .filter(i => i !== 'Ee')
        .join('')

      return (
        this.solElite.is_using && this.solElite.must_upgrade && flopBoard && flopBoard !== 'QsTs7h'
      )
    },
    hasElitePreflopOnly() {
      return (
        this.$store.getters.sol_data_street === 'preflop' &&
        this.solElite.is_using &&
        this.solElite.must_upgrade
      )
    },
    preflopOnlyGametype() {
      return this.$store.getters.preflopOnlyGametype
    },
    sol_noBoardCards() {
      return this.hSpot_street !== 'preflop' && this.sol_hsBoard.some(i => i.includes('E'))
    },
    sol_loading() {
      return this.sol_call.loading
    },
    sol_loaded() {
      return this.sol_call.loaded
    },
    sol_status() {
      return this.sol_call.status
    },
    sol_error() {
      return this.sol_call.error
    },
    historyCall() {
      return this.$store.getters.api_get(SNK('api_poker_history', this.primaryNamespace))
    },
    nextActionsCall() {
      return this.$store.getters.api_get(SNK('api_poker_next_actions', this.primaryNamespace))
    },
    historyLoading() {
      return this.nextActionsCall?.loading || this.historyCall?.loading
    },
    historyError() {
      return this.nextActionsCall?.error || this.historyCall?.error
    },
    sol_messages() {
      // TODO unify solMessages with builder and popups
      // return [
      // 'loading',
      // 'error_loading_solution',
      // 'error_400_TREE_IS_TOO_BIG',
      // 'custom_sols_flop_elite_only',
      // '204',
      // '204_elite',
      // '403',
      // '429',
      // 'preflopOnlyGametype',
      // 'select_board_strategy',
      // ]
      // console.log(this.historyError)
      const solutionTooBig =
        this.historyError?.status === 400 && this.historyError?.data?.code === 'TREE_IS_TOO_BIG'

      const opts = [
        { key: 'loading', val: this.sol_loading || this.historyLoading },

        { key: 'loading', val: this.solElite.loading_what === 'custom_solution' },
        { key: 'custom_sols_flop_elite_only', val: this.hasEliteSingleFlopOnly },
        { key: 'custom_sols_preflop_elite_only', val: this.hasElitePreflopOnly },
        { key: 'error_400_TREE_IS_TOO_BIG', val: solutionTooBig },
        { key: '204_elite', val: this.solElite.is_using && this.sol_status === 204 },

        { key: 'preflopOnlyGametype', val: !this.solElite.want_use && this.preflopOnlyGametype },
        { key: 'select_board_strategy', val: this.sol_noBoardCards },

        { key: '204', val: this.sol_status === 204 },
        { key: '403', val: this.sol_status === 403 },
        { key: '429', val: this.sol_status === 429 },
        { key: 'error_loading_solution', val: this.sol_call },
      ]
      let res = null

      opts.forEach(i => {
        if (!res && i.val) {
          res = [i.key]
        }
      })

      return res
    },
  },
  watch: {
    filterActive() {
      this.toggleSolProps()
    },
  },
}
</script>

<style lang="scss" scoped>
.slndcmp {
  &_messagebox {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    min-height: clamp(1px, 17rem, 100vw);
    min-width: clamp(1px, 17rem, 100vw);
    padding: 2rem 2rem;
  }
}
</style>
